import PropTypes from "prop-types";

export default PropTypes.shape({
  id: PropTypes.number,
  link: PropTypes.string,
  read: PropTypes.bool,
  time: PropTypes.string,
  subject: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.string,
});
